import * as React from "react";
import { useHistory } from "react-router-dom";
import { reloadOnStaleRelease } from "./staleBuild";

export default function StaleReleaseReload() {
  const history = useHistory();

  React.useEffect(
    () =>
      history.listen(
        reloadOnStaleRelease(window, import.meta.env.VITE_APP_VERSION),
      ),
    [history],
  );

  return null;
}
